import { render, staticRenderFns } from "./ShowAlianzaStores.vue?vue&type=template&id=65c0b010"
import script from "./ShowAlianzaStores.vue?vue&type=script&lang=js"
export * from "./ShowAlianzaStores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports